<template>
  <div
    v-if="
      Object.entries(storeData).length !== 0 && storeData.constructor === Object
    "
  >
    <div
      class="wrapper-content-items mb-7"
      :class="darkMode ? 'dark' : 'light'"
    >
      <statisticsStore class="mb-10" />
      <div class="wrapper-items-info">
        <div>
          <div class="wrapper-inputs">
            <label for="uploadLogo" class="upload">
              <div class="hover">
                <i class="ti-cloud-up"></i>
              </div>
              <img
                loading="lazy"
                v-if="storeData.logo"
                :src="`${$configKomercia.url}/logos/${storeData.logo}`"
                :alt="storeData.nombre"
              />
            </label>
            <input id="uploadLogo" type="file" @change="uploadLogo" />
          </div>
          <div>
            <p class="text-info mb-2">
              {{ $t("text_empresa_idTienda") }}
            </p>
            <p class="input-idTienda">
              {{ storeData.id }}
            </p>
          </div>
        </div>
        <div>
          <div class="content-items-info">
            <div class="input-area">
              <p class="text-info mb-2">
                {{ $t("text_empresa_nombreTienda") }}
              </p>
              <el-input
                v-model="storeData.nombre"
                class="inputs-idTienda"
                :class="darkMode ? 'darks-input' : 'light-input'"
                placeholder="Razón Social"
                onkeypress="return ((event.charCode>96 && event.charCode<105) || (event.charCode>47 && event.charCode<58) || (event.charCode>96 && event.charCode<123) || (event.charCode>64 && event.charCode<91) || (event.charCode==32) || (event.charCode==241) || (event.charCode==209))"
              >
              </el-input>
            </div>
            <div class="input-area">
              <p class="text-info mb-2">
                {{ $t("text_empresa_idioma") }}
              </p>
              <el-select
                v-model="storeData.informacion_tienda[0].lenguaje"
                filterable
                :placeholder="$t('text_empresa_idiomaTienda')"
                class="inputs-idTienda"
                :class="darkMode ? 'darks-input' : 'light-input'"
              >
                <el-option
                  v-for="(item, index) in idioms"
                  :key="index"
                  :label="item.nativeName"
                  :value="item.shortening"
                >
                  <span style="float: left; text-transform: capitalize">
                    {{ item.nativeName }}
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item.shortening }}
                  </span>
                </el-option>
              </el-select>
            </div>
            <div class="input-area">
              <p class="text-info mb-2">
                {{ $t("text_empresa_moneda") }}
              </p>
              <el-select
                v-model="storeData.informacion_tienda[0].moneda"
                filterable
                :placeholder="$t('text_empresa_seleccionaModenaTienda')"
                class="inputs-idTienda"
                :class="darkMode ? 'darks-input' : 'light-input'"
              >
                <el-option
                  v-for="(item, index) in currencies"
                  :key="index"
                  :label="item.CurrencyName"
                  :value="item.CurrencyCode"
                >
                  <span style="float: left; text-transform: capitalize">
                    {{ item.CurrencyName.toLowerCase() }}
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ item.CurrencyCode }}
                  </span>
                </el-option>
              </el-select>
            </div>
            <div class="input-area">
              <p class="text-info mb-2">
                {{ $t("text_empresa_pais") }}
              </p>
              <el-select
                v-model="storeData.informacion_tienda[0].paises_id"
                filterable
                :placeholder="$t('text_empresa_seleccionaPais')"
                class="inputs-idTienda"
                :class="darkMode ? 'darks-input' : 'light-input'"
                @change="updateData($event)"
              >
                <el-option
                  v-for="country in countries"
                  :key="country.id"
                  :label="country.pais"
                  :value="country.id"
                >
                  <span style="float: left; text-transform: capitalize">
                    {{ country.pais }}
                  </span>
                  <!-- <span
                        style="float: right; color: #8492a6; font-size: 13px"
                        >{{ country.shortening }}</span
                      > -->
                </el-option>
              </el-select>
            </div>
            <div class="input-area">
              <p class="text-info mb-2">
                {{ $t(placeholderDep) }}
              </p>
              <el-select
                v-model="departamentoactual"
                filterable
                :placeholder="$t(placeholderDep)"
                class="inputs-idTienda"
                :class="darkMode ? 'darks-input' : 'light-input'"
              >
                <el-option
                  v-for="item in departments"
                  :key="item.id"
                  :label="item.nombre_dep"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="input-area">
              <p class="text-info mb-2">
                {{ $t(placeholderCity) }}
              </p>
              <el-select
                v-model="ciudadactual.nombre_ciu"
                filterable
                :placeholder="$t(placeholderCity)"
                class="inputs-idTienda"
                :class="darkMode ? 'darks-input' : 'light-input'"
                @change="setCiudad()"
              >
                <el-option
                  v-for="item in ciudades"
                  :key="item.id"
                  :label="item.nombre_ciu"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="input-area">
              <p class="text-info mb-2">
                {{ $t("text_perfil_telefono") }}
              </p>
              <div v-if="wpVisible" class="w-full flex">
                <el-select
                  v-model="codeCountryPhone"
                  class="inputs-idTienda mr-2"
                  style="max-width: 80px"
                  :class="darkMode ? 'darks-input' : 'light-input'"
                  filterable
                  placeholder="País"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-input
                  v-model="storeData.informacion_tienda[0].telefono"
                  class="inputs-idTienda"
                  :class="darkMode ? 'darks-input' : 'light-input'"
                  :placeholder="$t('text_perfil_telefono')"
                  maxlength="10"
                  show-word-limit
                  onkeypress="return (event.charCode > 47 && event.charCode < 58)"
                >
                </el-input>
              </div>
              <div v-else class="w-full flex">
                <el-input
                  v-model="storeData.informacion_tienda[0].telefono"
                  class="inputs-idTienda"
                  :class="darkMode ? 'darks-input' : 'light-input'"
                  :placeholder="$t('text_perfil_telefono')"
                  :disabled="true"
                  @click="showInputWP"
                >
                </el-input>
                <el-button
                  class="wpbutton"
                  type="primary"
                  size="small"
                  style="height: 40px; margin-left: 5px; border-radius: 10px"
                  plain
                  @click="showInputWP"
                >
                  {{ $t("text_inventario_editar") }}
                </el-button>
              </div>
            </div>
            <div class="input-area">
              <p class="text-info mb-2">
                {{ $t("text_perfil_correoElectronico") }}
              </p>
              <el-input
                v-model="storeData.informacion_tienda[0].email_tienda"
                :placeholder="$t('text_perfil_correoElectronico')"
                class="inputs-idTienda"
                :class="darkMode ? 'darks-input' : 'light-input'"
              >
                <!-- <i
                  class="el-icon-question el-input__icon"
                  slot="suffix"
                  @click="
                    handleHelp(
                      'Correo Electrónico',
                      'Ej. soporte@tu-tienda.com'
                    )
                  "
                ></i> -->
              </el-input>
            </div>
            <div v-if="categoriesForStores" class="input-area">
              <p class="text-info mb-2">
                {{ $t("text_empresa_categoria") }}
              </p>
              <el-select
                v-model="storeData.categoria"
                filterable
                clearable
                :placeholder="$t('text_empresa_categoria')"
                class="inputs-idTienda"
                :class="darkMode ? 'darks-input' : 'light-input'"
              >
                <el-option
                  v-for="item in categoriesForStores"
                  :key="item.id"
                  :label="item.nombre_categoria"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="content-items-info-2 mt-3">
            <div class="input-area">
              <p class="text-info mb-2">
                {{ $t("text_empresa_palabrasClaves") }}
              </p>
              <el-input
                v-model="storeData.informacion_tienda[0].etiquetas"
                class="inputs-idTienda"
                :class="darkMode ? 'darks-input' : 'light-input'"
                :placeholder="$t('text_empresa_ropaCalzado')"
                onkeypress="return ((event.charCode>96 && event.charCode<105) || (event.charCode>47 && event.charCode<58) || (event.charCode>96 && event.charCode<123) || (event.charCode>64 && event.charCode<91) || (event.charCode==32) || (event.charCode==241) || (event.charCode==209))"
              >
              </el-input>
            </div>
            <div class="input-area">
              <p class="text-info mb-2">
                {{ $t("text_empresa_valorMinimoCompra") }}
              </p>
              <el-input
                v-model="storeData.informacion_tienda[0].valor_compra_minimo"
                class="inputs-idTienda-valor"
                :class="darkMode ? 'darks-input' : 'light-input'"
                type="number"
                :placeholder="$t('text_empresa_ventaMinima')"
                onkeypress="return ((event.charCode>96 && event.charCode<105) || (event.charCode>47 && event.charCode<58))"
                :min="0"
              >
                <i
                  slot="prefix"
                  class="el-input__icon fas el-icon-shopping-cart-2"
                />
                <i
                  slot="suffix"
                  class="el-icon-question el-input__icon"
                  @click="
                    handleHelp(
                      'Venta minima de compra',
                      'Configurar un valor mínimo total de compra en tu tienda puede ser útil, ya que prefieras no recibir compras pequeñas.'
                    )
                  "
                />
              </el-input>
            </div>
          </div>
          <div class="content-items-info-2 mt-3">
            <div class="input-area">
              <p class="text-info mb-2">
                {{ $t("text_empresa_regimen") }}
              </p>
              <el-select
                v-model="storeData.informacion_tienda[0].regimen"
                filterable
                clearable
                :placeholder="$t('text_empresa_regimen')"
                class="inputs-idTienda"
                :class="darkMode ? 'darks-input' : 'light-input'"
              >
                <el-option
                  v-for="(item, index) in listRegimen"
                  :key="index"
                  :label="item.label"
                  :value="item.label"
                ></el-option>
              </el-select>
            </div>
            <div class="input-area">
              <p class="text-info mb-2">
                {{ $t("text_empresa_nit") }}
              </p>
              <el-input
                v-model="storeData.informacion_tienda[0].nit"
                class="inputs-idTienda-valor"
                :class="darkMode ? 'darks-input' : 'light-input'"
                type="text"
                :placeholder="$t('text_empresa_nit')"
                onkeypress="return ((event.charCode>96 && event.charCode<105) || (event.charCode>47 && event.charCode<58))"
                :min="0"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 wrapper-description-Qr">
        <div class="wrapper-description">
          <p>
            {{ $t("text_inventario_description") }}
          </p>
          <el-input
            v-model="storeData.informacion_tienda[0].descripcion"
            class="input-description"
            type="textarea"
            :rows="4"
            :placeholder="$t('text_empresa_descripcionTienda')"
          >
          </el-input>
        </div>
        <div class="wrapper-qr-local">
          <div class="relative content-qr-local">
            <a title="Descargar QR" ref="download">
              <el-button type="text" class="btn-qr" @click="downloadQR()">
                <i class="el-icon-bottom" />
              </el-button>
              <qrcode
                id="qrcode"
                :key="widthQR"
                ref="qrcode"
                :value="getLink()"
                :options="{ width: widthQR }"
              ></qrcode>
            </a>
          </div>
          <div class="content-qr-local ml-8">
            <label for="uploadStore" class="upload" @click="widgetCloudinary()">
              <div class="hover">
                <i class="ti-cloud-up" />
              </div>
              <img
                loading="lazy"
                v-if="
                  storeData.fachada
                    ? idCloudinaryAwards(storeData.fachada, 130, 130)
                    : ''
                "
                :src="storeData.fachada"
                alt="fachadaTienda"
              />
              <div v-else class="wrapper-item-local">
                <i class="el-icon-top" />
                <p>{{ $t("text_empresa_agregarFotografia") }}</p>
              </div>
            </label>
            <input id="uploadStore" />
          </div>
        </div>
      </div>
      <div class="mt-5 w-full flex items-end justify-end">
        <el-button
          type="primary"
          class="button_save btn-save"
          @click="updateStoreData"
        >
          {{ $t("text_guardaCambios") }}
        </el-button>
      </div>
    </div>
    <div
      class="wrapper-content-items mb-7"
      :class="darkMode ? 'dark' : 'light'"
    >
      <div class="flex flex-col justify-center items-start">
        <p class="text-subdominio" :class="darkMode ? 'darktxt' : 'lighttxt'">
          {{ $t("text_empresa_subdominio") }}
          <i
            slot="suffix"
            class="el-icon-question el-input__icon"
            @click="
              handleHelp(
                'Subdominio',
                'Un subdominio es una forma de tener un sitio (web) relacionado, como anexo, a una web principal. Los subdominios son del tipo: https://subdominio.komercia.store.'
              )
            "
          ></i>
        </p>
        <div class="wrapper-items-subdominio">
          <div class="w-full flex flex-row">
            <div class="w-full flex flex-row input-subdominio justify-between">
              <div class="w-full flex flex-row">
                <span
                  style="color: #919191"
                  class="cursor-pointer"
                  @click="
                    handleHelp(
                      'Https',
                      'Es un protocolo que permite establecer una conexión segura entre el servidor y el cliente, que no puede ser interceptada por personas no autorizadas. En resumidas cuentas, es la versión segura de el http'
                    )
                  "
                >
                  https://
                </span>
                <!-- <p class="ml-2">{{ this.storeData.subdominio }}</p> -->
                <el-input
                  v-model="storeData.subdominio"
                  placeholder="subdominio"
                  onkeypress="return ((event.charCode>96 && event.charCode<105) || (event.charCode>47 && event.charCode<58) || (event.charCode>96 && event.charCode<123))"
                  class="inputs-dominio"
                  :class="darkMode ? 'darks-input' : 'light-input'"
                >
                </el-input>
              </div>
              <div class="header-copy" @click="getCopyLink">
                <span v-if="!stateCopy" style="font-size: 12px">
                  {{ copy }} <i class="far fa-clone"> </i>
                </span>
                <span v-else class="copy-text" style="font-size: 12px">
                  {{ copy }} <i class="far el-icon-check"></i>
                </span>
              </div>
            </div>
            <div
              class="ml-2 input-dominio"
              :class="darkMode ? 'dark-input-dominio' : 'light-input-dominio'"
            >
              <p class="text-dominio">
                {{
                  storeData.entidades &&
                  storeData.entidades.length > 0 &&
                  storeData.entidades[0].id == 21
                    ? ".keepbuy.co"
                    : storeData.template == 3
                    ? ".komercia.co"
                    : ".komercia.store"
                }}
              </p>
            </div>
          </div>
          <div class="w-full flex flex-row items-center wrapper-info-dominio">
            <i class="el-icon-success" />
            <p class="subtext-dominio">{{ $t("text_empresa_tuDominio") }}</p>
          </div>
          <button class="btn-subdominio" @click="handleSidebarHelp('1')">
            <i class="el-icon-chat-dot-round" />
            <p>{{ $t("text_empresa_necesitasAyuda") }}</p>
          </button>
        </div>
      </div>
    </div>
    <div
      class="wrapper-content-items Rectngulo-84"
      :class="darkMode ? 'dark' : 'light'"
    >
      <div
        class="flex flex-row justify-between items-center content-items-footer"
      >
        <div class="flex flex-row items-center content-img">
          <svg
            id="Grupo_252"
            data-name="Grupo 252"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="80.168"
            height="80.168"
            class="img1"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectángulo_85"
                  data-name="Rectángulo 85"
                  width="62"
                  height="63"
                  fill="#fff"
                />
              </clipPath>
            </defs>
            <g id="Grupo_227" data-name="Grupo 227">
              <g id="facebook">
                <path
                  id="Trazado_71"
                  data-name="Trazado 71"
                  d="M40.084,0A40.084,40.084,0,1,1,0,40.084,40.084,40.084,0,0,1,40.084,0Z"
                  fill="#303f9f"
                />
              </g>
              <g
                id="Enmascarar_grupo_5"
                data-name="Enmascarar grupo 5"
                transform="translate(9.134 8.574)"
                clip-path="url(#clip-path)"
              >
                <image
                  id="tidio-logo"
                  width="171"
                  height="77.89"
                  transform="translate(-7 -9)"
                  xlink:href="data:image/png;base64,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"
                />
              </g>
            </g>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="101.349"
            height="101.349"
            class="img2"
          >
            <g
              id="Grupo_253"
              data-name="Grupo 253"
              transform="translate(12.488) rotate(8)"
            >
              <g id="facebook" transform="translate(0 0)">
                <path
                  id="Trazado_71"
                  data-name="Trazado 71"
                  d="M44.867,0A44.867,44.867,0,1,1,0,44.867,44.867,44.867,0,0,1,44.867,0Z"
                  fill="#fff"
                />
              </g>
              <g id="google" transform="translate(17.509 17.509)">
                <path
                  id="Trazado_111"
                  data-name="Trazado 111"
                  d="M24.651,0H1.825A1.825,1.825,0,0,0,0,1.825V9.117a1.825,1.825,0,0,0,1.825,1.825H14.679A17.159,17.159,0,0,1,7.293,19.6l5.481,9.488A27.436,27.436,0,0,0,26.764,5.091a18.486,18.486,0,0,0-.315-3.583A1.833,1.833,0,0,0,24.651,0Z"
                  transform="translate(29.197 23.114)"
                  fill="#167ee6"
                />
                <path
                  id="Trazado_112"
                  data-name="Trazado 112"
                  d="M24.219,8.523A17.028,17.028,0,0,1,9.488,0L0,5.469a27.943,27.943,0,0,0,24.219,14,27.934,27.934,0,0,0,13.99-3.748v-.013L32.728,6.223A16.9,16.9,0,0,1,24.219,8.523Z"
                  transform="translate(3.761 36.489)"
                  fill="#12b347"
                />
                <path
                  id="Trazado_113"
                  data-name="Trazado 113"
                  d="M13.99,9.5V9.488L8.509,0A16.9,16.9,0,0,1,0,2.3V13.249A27.932,27.932,0,0,0,13.99,9.5Z"
                  transform="translate(27.98 42.711)"
                  fill="#0f993e"
                />
                <path
                  id="Trazado_114"
                  data-name="Trazado 114"
                  d="M10.949,13.977a16.905,16.905,0,0,1,2.3-8.509L3.761,0a27.852,27.852,0,0,0,0,27.954l9.488-5.469A16.9,16.9,0,0,1,10.949,13.977Z"
                  transform="translate(0 14.003)"
                  fill="#ffd500"
                />
                <path
                  id="Trazado_115"
                  data-name="Trazado 115"
                  d="M24.219,10.949a16.953,16.953,0,0,1,10.813,3.882,1.818,1.818,0,0,0,2.446-.11l5.167-5.167a1.839,1.839,0,0,0-.105-2.689A27.919,27.919,0,0,0,0,14l9.488,5.469A17.028,17.028,0,0,1,24.219,10.949Z"
                  transform="translate(3.761 0)"
                  fill="#ff4b26"
                />
                <path
                  id="Trazado_116"
                  data-name="Trazado 116"
                  d="M10.813,14.831a1.818,1.818,0,0,0,2.446-.11l5.167-5.167a1.839,1.839,0,0,0-.105-2.689A27.9,27.9,0,0,0,0,0V10.949A16.954,16.954,0,0,1,10.813,14.831Z"
                  transform="translate(27.98 0)"
                  fill="#d93f21"
                />
              </g>
            </g>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="104"
            height="104"
            class="img3"
          >
            <g
              id="facebook"
              transform="matrix(0.985, -0.174, 0.174, 0.985, 0, 15.589)"
            >
              <path
                id="Trazado_71"
                data-name="Trazado 71"
                d="M44.887,0A44.887,44.887,0,1,1,0,44.888,44.888,44.888,0,0,1,44.887,0Z"
                transform="translate(0)"
                fill="#3b5998"
              />
              <path
                id="Trazado_72"
                data-name="Trazado 72"
                d="M16.721,8.545h5.785V0h-6.8V.031C7.465.323,5.777,4.954,5.628,9.819H5.611v4.267H0v8.369H5.611V44.887h8.456V22.455h6.927l1.338-8.369H14.069V11.508A2.756,2.756,0,0,1,16.721,8.545Z"
                transform="translate(33.632 22.357)"
                fill="#fff"
              />
            </g>
          </svg>
        </div>
        <p class="text-footer">
          <i class="el-icon-circle-plus-outline" />
          {{ $t("text_empresa_agregarIntegracionesOnline") }}
        </p>
        <router-link to="/integraciones" class="btn-footer">
          {{ $t("text_empresa_irIntegraciones") }}
        </router-link>
      </div>
    </div>
    <div v-if="false" class="grid">
      <div class="input-area">
        <p class="input-label">
          {{ $t("text_inventario_description") }}
          <i
            slot="suffix"
            class="el-icon-question el-input__icon"
            @click="handleHelp('Descripción', 'Todo acerca de tu tienda')"
          ></i>
        </p>
        <vue-editor
          id="descripcion"
          v-model="storeData.informacion_tienda[0].descripcion"
        ></vue-editor>
      </div>
      <div class="input-area">
        <p class="input-label">Nosotros</p>
        <vue-editor
          id="nosotros"
          v-model="storeData.paginas_tienda[0].nosotros"
        ></vue-editor>
      </div>
      <div class="input-area">
        <p class="input-label">Misión</p>
        <vue-editor
          id="mision"
          v-model="storeData.paginas_tienda[0].mision"
        ></vue-editor>
      </div>
      <div class="input-area">
        <p class="input-label">Visión</p>
        <vue-editor
          id="vision"
          v-model="storeData.paginas_tienda[0].vision"
        ></vue-editor>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import debounce from "lodash.debounce";
import { mapState } from "vuex";
import cloudinaryWidgetOptions from "@/mixins/cloudinaryWidgetOptions";
import getIdCloudinary from "@/mixins/getIdCloudinary";
import idCloudinaryAwards from "@/mixins/idCloudinary";
import statisticsStore from "./statistics/stats-store.vue";

export default {
  name: "informationStore",
  components: { statisticsStore },
  mixins: [cloudinaryWidgetOptions, getIdCloudinary, idCloudinaryAwards],
  data() {
    return {
      codeCountryPhone: null,
      wpVisible: false,
      options: [
        {
          value: "+54",
          label: "+54   Argentina",
        },
        {
          value: "+55",
          label: "+55   Brasil",
        },
        {
          value: "+56",
          label: "+56 Chile",
        },
        {
          value: "+57",
          label: "+57   Colombia",
        },
        {
          value: "+593",
          label: "+593  Ecuador",
        },
        {
          value: "+34",
          label: "+34 España",
        },
        {
          value: "+1",
          label: "+1 Estados Unidos",
        },
        {
          value: "+52",
          label: "+52 México",
        },
        {
          value: "+51",
          label: "+51 Perú",
        },
        {
          value: "+1",
          label: "+1 Puerto Rico",
        },
        {
          value: "+1",
          label: "+1 República Dominicana",
        },
        {
          value: "+507",
          label: "+507 Panamá",
        },
      ],
      copy: "Copiar",
      stateCopy: false,
      isLoading: false,
      loadingSavePhotoMain: false,
      myUploadWidget: null,
      widthQR: 128,
      loadingSubdomain: false,
      subdomainIsValid: true,
      subdominioTMP: "",
      firstTime: false,
      currentCurrency: "COP",
      currencies: [
        {
          CurrencyCode: "USD",
          CurrencyName: "Dolar estadounidense",
        },
        {
          CurrencyCode: "COP",
          CurrencyName: "Peso Colombiano",
        },
        {
          CurrencyCode: "CLP",
          CurrencyName: "Peso chileno",
        },
        {
          CurrencyCode: "ARS",
          CurrencyName: "Peso argentino",
        },
        {
          CurrencyCode: "AUD",
          CurrencyName: "Dolar australiano",
        },
        {
          CurrencyCode: "BRL",
          CurrencyName: "Real Brasileño",
        },
        {
          CurrencyCode: "CAD",
          CurrencyName: "Dolar canadiense",
        },
        {
          CurrencyCode: "EUR",
          CurrencyName: "Euro",
        },
        {
          CurrencyCode: "GBP",
          CurrencyName: "Libra esterlina británica",
        },
        {
          CurrencyCode: "MXN",
          CurrencyName: "peso mejicano",
        },
        {
          CurrencyCode: "PEN",
          CurrencyName: "Nuevo Sol peruano",
        },
        {
          CurrencyCode: "VEF",
          CurrencyName: "Venezuela Bolívar Fuerte",
        },
      ],
      currentLanguage: "es",
      idioms: [
        {
          name: "English",
          shortening: "en",
          nativeName: "English",
        },
        {
          name: "Spanish",
          shortening: "es",
          nativeName: "Español",
        },
        {
          name: "Portuguese",
          shortening: "pt",
          nativeName: "Português",
        },
        {
          name: "French",
          shortening: "fr",
          nativeName: "français",
        },
      ],
      listRegimen: [
        {
          label: "Régimen simplificado",
        },
        {
          label: "Régimen común",
        },
      ],
      placeholderDep: "text_empresa_departamento",
      placeholderCity: "text_perfil_ciudad",
    };
  },
  computed: {
    ...mapState([
      "categoriesForStores",
      "countries",
      "departments",
      "darkMode",
      "currentCountry",
    ]),
    storeData: {
      get() {
        return this.$store.state.storeData;
      },
      set(newValue) {
        this.$store.state.storeData = newValue;
      },
    },
    ciudadactual() {
      return this.storeData.ciudad;
    },
    departamentoactual: {
      get() {
        return this.storeData.ciudad.departamento.id;
      },
      set(newValue) {
        this.storeData.ciudad.departamento.id = newValue;
      },
    },
    ciudades() {
      return this.$store.state.cities.filter(
        (ciudad) => ciudad.dep === this.storeData.ciudad.departamento.id
      );
    },
    activePlan() {
      if (this.storeData.fecha_expiracion == null) {
        return true;
      } else {
        let x = this.storeData.fecha_expiracion;
        let d1 = new Date();
        let d2 = new Date(x);
        //Vencido
        if (d1 > d2) {
          return false;
        }
        //Activo
        else {
          return true;
        }
      }
    },
  },
  watch: {
    "storeData.subdominio"(value) {
      if (RegExp("^[a-zA-Z0-9_]*$").test(value)) {
        if (this.firstTime) {
          this.loadingSubdomain = true;
          this.validateSubdomain();
        } else {
          this.firstTime = true;
          this.subdominioTMP = value;
        }
      } else {
        this.$message.error(
          "El subdominio no debe tener espacios ni caracteres especiales"
        );
        this.subdomainIsValid = false;
      }
    },
    countries() {
      this.setPlaceholderDep();
    },
    ciudades() {
      this.setPlaceholderDep();
    },
    currentCountry() {
      this.$store.dispatch("GET_DEPARTMENTS");
    },
  },
  created() {
    this.$store.dispatch("GET_COUNTRIES");
    if (this.currentCountry) {
      this.$store.dispatch("GET_DEPARTMENTS");
    }
    setTimeout(this.setPlaceholderDep, 1000);
    if (this.storeData?.informacion_tienda[0]?.telefono == "") {
      this.wpVisible = true;
    }
  },
  methods: {
    showInputWP() {
      this.storeData.informacion_tienda[0].telefono = "";
      this.wpVisible = true;
    },
    getLink() {
      const suffix =
        this.storeData?.entidades?.length > 0 &&
        this.storeData.entidades[0]?.id == 21
          ? "co"
          : this.storeData.template !== 3
          ? "store"
          : "co";
      if (this.storeData.informacion_tienda[0].dominio) {
        return this.storeData.informacion_tienda[0].dominio;
      } else {
        if (
          this.storeData.entidades &&
          this.storeData.entidades.length > 0 &&
          this.storeData.entidades[0].id == 21
        ) {
          return `http://${this.storeData.subdominio}.keepbuy.${suffix}`;
        } else {
          return `http://${this.storeData.subdominio}.komercia.${suffix}`;
        }
      }
    },
    async downloadQR() {
      this.widthQR = await 600;
      this.$nextTick(() => {
        let ctx = document.getElementById("qrcode");
        if (ctx.msToBlob) {
          //para internet explorer
          const blob = ctx.msToBlob();
          window.navigator.msSaveBlob(blob, "codigoqr" + ".png"); // la extensión de preferencia pon jpg o png
        } else {
          const link = this.$refs.download;
          //Otros navegadores: Google chrome, Firefox etc...
          link.href = ctx.toDataURL("image/png"); // Extensión .png ("image/png") --- Extension .jpg ("image/jpeg")
          link.download = "codigoqr";
        }
        this.widthQR = 128;
      });
    },
    setCiudad() {
      let ciudadfinal = this.ciudades.find(
        (ciudadid) => ciudadid.id === this.storeData.ciudad.nombre_ciu
      );
      this.storeData.ciudad = ciudadfinal;
    },
    handleSidebarHelp(contentId) {
      this.$store.state.miscSidebar.isActive = true;
      this.$store.state.miscSidebar.isHelpdesk = false;
      this.$store.state.miscSidebar.data = contentId;
    },
    handleHelpBlogKomercia(cat, art) {
      window.open(`${art}`, "_blank");
      // this.$router.push({
      //   path: '',
      //   query: { help: true, category: cat, art: art },
      // })
    },
    async updateStoreData() {
      let phone;
      if (this.codeCountryPhone == null) {
        phone = this.storeData.informacion_tienda[0].telefono;
      } else {
        phone =
          this.codeCountryPhone + this.storeData.informacion_tienda[0].telefono;
        this.storeData.informacion_tienda[0].telefono = phone;
      }
      if (this.subdomainIsValid) {
        let params = {
          nombre: this.storeData.nombre,
          categoria: this.storeData.categoria,
          telefono: phone,
          departamento: this.storeData.ciudad.departamento.id,
          ciudad: this.storeData.ciudad.id,
          email: this.storeData.informacion_tienda[0].email_tienda,
          descripcion: this.storeData.informacion_tienda[0].descripcion,
          nosotros: this.storeData.paginas_tienda[0].nosotros,
          mision: this.storeData.paginas_tienda[0].mision,
          vision: this.storeData.paginas_tienda[0].vision,
          facebook: this.storeData.redes[0].facebook,
          instagram: this.storeData.redes[0].instagram,
          twitter: this.storeData.redes[0].twitter,
          youtube: this.storeData.redes[0].youtube,
          whatsapp: this.storeData.redes[0].whatsapp,
          tiktok: this.storeData.redes[0].tiktok,
          subdominio: this.storeData.subdominio,
          moneda: this.storeData.informacion_tienda[0].moneda,
          lenguaje: this.storeData.informacion_tienda[0].lenguaje.toLowerCase(),
          pais: this.storeData.informacion_tienda[0].paises_id,
          etiquetas: this.storeData.informacion_tienda[0].etiquetas,
          nit: this.storeData.informacion_tienda[0].nit,
          regimen: this.storeData.informacion_tienda[0].regimen,
          fachada: this.storeData.fachada,
          minimo_compra:
            this.storeData.informacion_tienda[0].valor_compra_minimo,
        };
        const { status } = await this.$store.dispatch("UPDATE_STORE", params);
        if (status === 200) {
          this.$swal("Información actualizada correctamente!", "", "success");
          this.$store.dispatch("GET_STORE");
          this.wpVisible = false;
          // this.$message.success('Informacion actualizada correctamente')
        } else {
          this.$swal("Error de actualización!", "", "error");
        }
      } else {
        this.$swal("Cambia el subdominio por uno disponible!", "", "info");
        // this.$message.error('Cambia el subdominio por uno disponible')
      }
    },

    async uploadLogo(event) {
      let file = event.target.files[0];
      if (file.size <= 6000000) {
        if (file.type.match("image.*")) {
          const formData = new FormData();
          formData.append("logo", file);
          try {
            const { data } = await axios({
              method: "POST",
              url: `${this.$configKomercia.url}/api/admin/tienda/logo/cambiar`,
              data: formData,
              headers: this.$store.state.configAxios.headers,
            });
            if (data) {
              try {
                const response = await axios({
                  method: "GET",
                  url: `${this.$configKomercia.urlKomerciaAWS}/api/v1/stores/logos/${this.storeData.id}`,
                  headers: {
                    KOMERCIA_PUBLIC_ROUTES_KEY: this.$store.state.routerKey,
                  },
                });
                console.log(response.data.data.logoMigrated);
                if (
                  response.data.data.logoMigrated ||
                  response.data.data.logoMigrated == 1
                ) {
                  console.log("Logo migrado");
                  try {
                    const response = await axios({
                      method: "PUT",
                      url: `${this.$configKomercia.urlKomerciaAWS}/api/v1/cloudinary/sync-store-logo/${this.storeData.id}`,
                      headers: this.$store.state.configAxios.headers,
                    });
                  } catch (err) {
                    console.error(`Error al cambiar logo `);
                  }
                }
              } catch (err) {
                console.error(`Error al cambiar logo `);
              }

              this.storeData.logo = data.data.logo;
              this.$store.commit("SET_TASK", { id: 3, status: true });
            }
          } catch (err) {
            console.error(`Error al cambiar logo `);
          }
        } else {
          this.$message.error(
            "El tipo de archivo no corresponde con el requerido. (jpg, png, gif, svg)"
          );
        }
      } else {
        this.$message.error("El archivo supera las 6 Megas");
      }
    },
    validateSubdomain: debounce(function () {
      let params = {
        subdominio: this.storeData.subdominio,
      };
      axios
        .post(
          `${this.$configKomercia.url}/api/verificar/subdominio`,
          params,
          this.$store.state.configAxios
        )
        .then(() => {
          this.$message.success("Este subdominio si esta disponible");
          this.loadingSubdomain = false;
          this.subdomainIsValid = true;
        })
        .catch(() => {
          if (this.subdominioTMP === this.storeData.subdominio) {
            this.$message.success("Este subdominio es el mismo que utilizas");
            this.loadingSubdomain = false;
            this.subdomainIsValid = true;
          } else {
            this.$message.warning("Este subdominio ya esta ocupado");
            this.loadingSubdomain = false;
            this.subdomainIsValid = false;
          }
        });
    }, 2000),
    redirectTo() {
      this.$router.push("/");
    },
    handleHelp(title, description) {
      this.$alert(description, title);
    },
    widgetCloudinary() {
      this.myUploadWidget = cloudinary.openUploadWidget(
        this.cloudinaryWidgetOptions("assets", "djfvsebry", "fachadatiendas"),
        (error, result) => {
          this.afterUpload(error, result);
        }
      );
      this.myUploadWidget.open();
    },
    async afterUpload(error, result) {
      if (result.event === "success") {
        if (this.storeData.fachada) {
          const { success } = await this.deleteImageCloudinary(
            this.storeData.fachada,
            "assets"
          );
          if (success) {
            this.storeData.fachada = result.info.secure_url;
          }
        } else {
          this.storeData.fachada = result.info.secure_url;
        }
        this.myUploadWidget.close();
      }
    },
    async deleteImageCloudinary(image, type) {
      try {
        const { data } = await axios({
          method: "POST",
          url: `${this.$store.state.configKomercia.url}/api/admin/cloudinary/delete`,
          headers: this.$store.state.configAxios.headers,
          data: {
            image: this.getIdCloudinary(image),
            tipo: type,
            template: this.storeData.template,
          },
        });
        if (data && data.estado === 200) {
          return { success: true, data: data };
        }
      } catch (err) {
        console.log("Error delete cloudinary", err.response.data);
      }
    },
    getCopyLink() {
      const el = document.createElement("textarea");
      el.value = `https://${this.storeData.subdominio}${
        this.storeData.entidades &&
        this.storeData.entidades.length > 0 &&
        this.storeData.entidades[0].id == 21
          ? ".keepbuy.co"
          : this.storeData.template == 3
          ? ".komercia.co"
          : ".komercia.store"
      }`;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.copy = "Copiado";
      this.stateCopy = true;
    },
    setPlaceholderDep() {
      if (this.storeData?.informacion_tienda?.length) {
        switch (this.storeData.informacion_tienda[0].paises_id) {
          case 1:
            this.placeholderDep = "text_empresa_departamento";
            this.placeholderCity = "text_perfil_ciudad";
            break;
          case 2:
            this.placeholderDep = "text_empresa_estado";
            this.placeholderCity = "text_perfil_ciudad";
            break;
          case 3:
            this.placeholderDep = "text_empresa_estado";
            this.placeholderCity = "text_perfil_ciudad";
            break;
          case 6:
            this.placeholderDep = "text_empresa_region";
            this.placeholderCity = "text_perfil_ciudad";
            break;
          case 7:
            this.placeholderDep = "text_empresa_region";
            this.placeholderCity = "text_perfil_ciudad";
            break;
          case 8:
            this.placeholderDep = "text_empresa_municipios";
            this.placeholderCity = "text_perfil_ciudad";
            break;
          case 9:
            this.placeholderDep = "text_empresa_departamento";
            this.placeholderCity = "text_perfil_ciudad";
            break;
          case 10:
            this.placeholderDep = "text_empresa_provincia";
            this.placeholderCity = "text_empresa_distrito";
            break;
          default:
            this.placeholderDep = "text_empresa_departamento";
            this.placeholderCity = "text_perfil_ciudad";
        }
      }
    },
    updateData(idCountry) {
      this.$store.dispatch("UPDATE_DEPARTMENTS", idCountry);
      this.setPlaceholderDep();
    },
  },
};
</script>

<style scoped>
.dark {
  background-color: #1b2836;
}
.light {
  @apply bg-white;
}
.darks {
  background-color: #1f2937;
}
.lights {
  background-color: #fff;
}
.darktxt {
  color: #fff;
}
.lighttxt {
  color: #333;
}
.wrapper-items-info {
  display: grid;
  grid-template-columns: 1fr 4fr;
  grid-template-rows: 1fr;
  grid-column-gap: 25px;
  grid-row-gap: 0px;
}
.content-items-info {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 16px;
}
.content-items-info-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
}
.text-info {
  font-size: 12px;
  font-weight: 500;
  color: #919191;
}
.input-area {
  width: 100%;
}
.input-idTienda {
  padding: 12px 11px;
  border-radius: 10px;
  background-color: #f2efff;
  font-size: 13px;
  max-height: 40px;
}
.inputs-idTienda >>> .el-input__inner {
  padding: 0px 15px;
  font-size: 13px;
  border-radius: 10px;
  border: solid 2px #f3f4f6;
  background-color: transparent;
  transition: none;
  max-height: 40px;
}
.inputs-idTienda-valor >>> .el-input__inner {
  padding: 0px 25px;
  font-size: 13px;
  border-radius: 10px;
  border: solid 2px #f3f4f6;
  background-color: transparent;
  transition: none;
  max-height: 40px;
}
.inputs-dominio >>> .el-input__inner {
  font-size: 13px;
  border: none;
  background-color: transparent;
  transition: none;
  padding: 0px;
  height: 20px;
  max-height: 20px;
  @apply ml-2;
}
.darks-input >>> .el-input__inner {
  color: #f3f4f6;
}
.light-input >>> .el-input__inner {
  color: #1f2937;
}
.wrapper-description-Qr {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 25px;
  grid-row-gap: 0px;
}
.wrapper-description {
  padding: 20px 30px;
  border-radius: 15px;
  background-color: #f2efff;
}
.wrapper-description p {
  font-size: 12px;
  font-weight: 500;
  color: #919191;
}
.input-description >>> .el-textarea__inner {
  padding: 10px 0px;
  color: #1f2937;
  background-color: transparent;
  border: none;
  transition: none;
  resize: none;
}
.wrapper-qr-local {
  padding: 20px 30px;
  border-radius: 15px;
  background-color: #f2efff;
  @apply flex flex-row justify-between text-center;
}
.content-qr-local {
  max-height: 128px;
}
.btn-qr {
  top: 0;
  left: 0;
  position: absolute;
  width: 128px;
  height: 128px;
  z-index: 2;
}
.btn-qr i {
  padding: 4px;
  border-radius: 100%;
  font-size: 18px;
  color: white;
  background: #00d57e;
}
.btn-qr:hover i {
  background: #4429b4;
}
.wrapper-item-local {
  @apply flex flex-col items-center;
}
.wrapper-item-local i {
  padding: 4px !important;
  border-radius: 100% !important;
  font-size: 18px !important;
  color: white !important ;
  background: #00d57e !important;
  margin-bottom: 5px;
}
.upload {
  position: relative;
  width: 130px;
  height: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  overflow: hidden;
}
.upload .hover {
  position: absolute;
  opacity: 0;
  border-color: #818592;
  background-color: rgba(255, 255, 255, 0.5);
  transition: 0.3s;
}
.upload .hover i {
  color: #818592;
}
.upload .hover:hover {
  opacity: 1;
}
.upload img {
  max-width: 100%;
  max-height: 100%;
}
.upload div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 2px dashed #d8dce5;
}
.upload div i {
  font-size: 35px;
  color: #00d57e;
}
.upload:hover div i {
  font-size: 35px;
  color: #4429b4;
}
.upload:hover div {
  border: 2px dashed #4429b4;
}
#uploadLogo {
  visibility: hidden;
  opacity: 0;
  width: 0;
  height: 0;
}
#uploadStore {
  visibility: hidden;
  opacity: 0;
  width: 0;
  height: 0;
}
.wrapper-item-local p {
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: #1f2937;
}
.wrapper-content-items {
  width: 100%;
  padding: 30px 40px;
  border-radius: 12px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.09);
}
.wrapper-items-subdominio {
  display: grid;
  grid-template-columns: 3fr repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 0px;
  @apply w-full mt-3 items-center;
}
.input-subdominio {
  width: 100%;
  padding: 11px 16px;
  border-radius: 9px;
  background-color: #f2efff;
}
.input-dominio {
  padding: 13px 25px 12px;
  border-radius: 7px;
}
.dark-input-dominio {
  background-color: #00d57e;
}
.light-input-dominio {
  background-color: #00d57c46;
}
.text-dominio {
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #1f2937;
}
.text-subdominio {
  font-size: 18px;
  font-weight: 600;
}
.wrapper-info-dominio i {
  margin-right: 5px;
  font-size: 10px;
  color: #00d57e;
}
.wrapper-info-dominio p {
  font-size: 10px;
  font-weight: 500;
  line-height: 1.5;
  color: #919191;
}
.btn-save {
  width: 100%;
  max-width: 220px;
  height: 42px;
  padding: 13px 30px;
  border-radius: 10px;
  font-size: 12px;
}
.btn-subdominio {
  width: 100%;
  max-width: 220px;
  height: 42px;
  padding: 13px 30px;
  border-radius: 10px;
  background-color: #4429b4;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-subdominio i {
  margin-right: 5px;
  font-size: 26px;
  color: #00d57e;
}
.btn-subdominio p {
  font-size: 12px;
  color: #fff;
}
.Rectngulo-84 {
  overflow: hidden;
  max-height: 75px;
  background: rgb(68, 41, 180);
  background: linear-gradient(
    90deg,
    rgba(68, 41, 180, 1) 0%,
    rgba(0, 213, 126, 1) 100%
  );
}
.content-items-footer {
  position: relative;
  top: -10px;
}
.content-img {
  width: 100%;
  max-width: 220px;
  max-height: 75px;
  box-sizing: content-box;
  position: relative;
}
.img1 {
  position: absolute;
  left: -25px;
}
.img2 {
  position: absolute;
  left: 38px;
  z-index: 2;
}
.img3 {
  position: absolute;
  left: 110px;
  z-index: 3;
}
.text-footer {
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-footer i {
  margin-right: 5px;
  font-size: 26px;
  color: #00d57e;
}
.btn-footer {
  width: 100%;
  max-width: 220px;
  height: 42px;
  padding: 13px 30px;
  border-radius: 10px;
  background-color: #2beda8;
  color: #4429b4;
  text-align: center;
}
.logo {
  display: flex;
  align-items: center;
}
.wrapper-inputs {
  display: flex;
}
.header-copy {
  width: 85px;
  background: transparent;
  cursor: pointer;
}
.copy-text {
  color: green;
}
@media (max-width: 1024px) {
  .wrapper-content-items {
    padding: 30px 20px;
  }
  .btn-footer {
    max-width: 162px;
    font-size: 12px;
    padding: 5px 30px;
  }
  .btn-save {
    max-width: 162px;
  }
}
</style>
